import React, { useContext, useEffect, useState } from 'react'
import Style from "./index.module.css"
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb';
import Navbar from '../../../Components/Navbar/Navbar';
import Footer from '../../../Components/Footer/Footer';
import NotificationCard from '../../../Components/Cards/NotificationCard/NotificationCard';
import { UserContext } from '../../../Contexts/UserContext';
import authInstance from '../../../instance/AuthInstance';
import NotificationModal from '../../../Components/Notification_Modal/Modal'
import Backlogo from "../../../Assets/Icons/Back"
import Logo from '../../../Assets/Images/logo.webp'
import TimeAgo from "react-timeago";
import { useTranslation } from 'react-i18next';

const NotificationPage = () => {
  const { t } = useTranslation()

  const LoggedInUser = useContext(UserContext);
  const { User } = LoggedInUser

  const [Reload, SetReload] = useState(false);
  const [Alert, SetAlert] = useState([]);
  const [isOpen, SetIsOpen] = useState(false)
  const [selectedAlert, setSelectedAlert] = useState(null)

  const location = useLocation();
  const pathSegment = location.pathname.split('/').filter((segment) => segment);

  function ScrollToTopOnMount() {
    window.scrollTo(0, 0);
    return null;
  }

  useEffect(() => {
    ScrollToTopOnMount();
  }, []);



  //Function to get Notification
  useEffect(() => {
    try {
      if (User?._id) {
        console.log('[FRONTEND_DEBUG] NotificationPage mounted, User ID:', User._id);

        // Fetch notifications
        authInstance.get(`/api/user/notification/get_notification?userId=${User?._id}`).then((response) => {
          console.log('[FRONTEND_DEBUG] Fetched notifications:', response.data.length);
          SetAlert(response.data)
          SetReload(false)
        });

        // Mark all as read when page opens
        console.log('[FRONTEND_DEBUG] Calling mark-all-read endpoint...');
        authInstance.patch(`/api/user/notification/mark-all-read/${User._id}`)
          .then((response) => {
            console.log('[FRONTEND_DEBUG] Mark-all-read SUCCESS:', response.data);
            // Update local badge count immediately
            window.dispatchEvent(new Event('refreshNotificationCount'));
          })
          .catch(err => {
            console.error("[FRONTEND_DEBUG] Mark-all-read FAILED:", err);
            console.error("[FRONTEND_DEBUG] Error response:", err.response);
          });
      }
    } catch (error) {
      console.log(error);
    }
  }, [User?._id, Reload])

  //Function to Mark Notification Readed & Open Modal
  const handleRead = (alert) => {
    setSelectedAlert(alert);
    SetIsOpen(true);
    document.body.style.overflow = 'hidden';

    // Only mark as read if not already read
    const isRead = alert?.read?.some(id => id.toString() === User?._id);
    if (!isRead) {
      // Optimistic update: Add user to read array locally
      const updatedAlerts = Alert.map(a =>
        a._id === alert._id
          ? { ...a, read: [...(a.read || []), User?._id] }
          : a
      );
      SetAlert(updatedAlerts);

      authInstance.post(`/api/user/notification/mark`, { userId: User?._id, notificationId: alert?._id }).then((response) => {
        window.dispatchEvent(new Event('refreshNotificationCount'));
        SetReload(true)
      }).catch((err) => {
        console.log(err);
      })
    }
  };

  const closeModal = () => {
    SetIsOpen(false);
    document.body.style.overflow = 'auto';


  };

  console.log(Alert, "not data")

  return (
    <div className={Style.page_wrapper}>
      <ScrollToTopOnMount />
      <Navbar reload={Reload} />
      <div className={Style.main}>
        <Breadcrumb pathSegments={pathSegment} />
        <div className={Style.productwrapper}>
          <div className={Style.container}>
            <div className={Style.heading}>
              <div className={Style.left}>
                <h2>{t("notification")}</h2>
              </div>
              <div className={Style.right}>
              </div>
            </div>
            {Alert.length !== 0 ? (
              <div className={Style.cardWrapper}>
                <NotificationCard
                  HandleRead={handleRead}
                  Alert={Alert}
                  User={User}
                />
              </div>
            ) : (
              <div className={Style.imgWrapper}>
                <img src="/Images/message.svg" alt="" />
              </div>
            )}
          </div>
        </div>
        <NotificationModal isOpen={isOpen} onClose={closeModal}>
          {selectedAlert && (
            <div className={Style.modal_wrapper}>
              <div className={Style.modal_container}>
                <div className={Style.closeIcon_wrapper} onClick={closeModal}>
                  <Backlogo className={Style.back_logo} />
                </div>
                <div className={Style.left_container}>
                  <div className={Style.modal_img}>
                    <img src={Logo} alt="notification logo" />
                  </div>
                </div>
                <div className={Style.right_container}>
                  <h6>{selectedAlert?.title || selectedAlert?.notification}</h6>
                  <p>{selectedAlert?.message || "Notification message"}</p>
                  <span className={Style.time_shower}> <TimeAgo date={selectedAlert?.createdAt} minPeriod={60} /> </span>
                </div>
              </div>
            </div>
          )}
        </NotificationModal>

        <Footer />
      </div>
    </div>
  );
}

export default NotificationPage